import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class ProductsHome extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            
            loading : 1,
            products:this.props.products, 
            content:this.props.content, 
            
        }
        

    }
     
    componentDidMount()
    {  
        
        if(this.props.products && this.state.loading === 1)
        {
             this.setState({loading:0});     
        }

        const script = document.createElement("script");
        script.src   = base_url+"assets/js/loadSlider.js";  
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
        if (window.loadSlider && this.state.loading == 0 && this.props.products.length > 0) {
        window.loadProductsHome();
        this.setState({loading:0})
        }
        };
         
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (

        <div className="services-area carousel-shadow flex-less inc-thumb default-padding ba" >
        <div className="container">
            <div className="row">
                <div className="col-md-8 col-md-offset-2">
                    <div className="site-heading text-center">
                        <h4>{this.state.content[2]['title']}</h4>
                        <h2>{this.state.content[2]['subtitle']}</h2>
                        <div dangerouslySetInnerHTML={{ __html: this.state.content[2].description }} />    
                       
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="services-items services-carousel-3-col owl-carousel owl-theme text-center inc-overlay">
                      <div className="item">
                            <div className="thumbs overlay">
                                <img src={base_url+"assets/img/galvanizedISD.jpeg"} alt="Galvanized Iron Steel Ducts" />
                                <div className="info">
                                  <h4>Galvanized Iron Steel Ducts</h4>
                                  <p>
                                  Galvanized Iron Steel Ducts
                                  </p>
                                  <Link to="/">Read More</Link>
                                </div>
                            </div>
                            <div className="info">
                                <div className="content">
                                    <div className="top-info">
                                        <h4><Link to="/">Galvanized Iron Steel Ducts</Link></h4>
                                    </div>
                                    
                                </div>
                            </div>
                        </div> 
                    {this.state.products.map((item, index) => (

                        <div className="item">
                            <div className="thumbs overlay">
                                <img src={item.image} alt={item.title} />
                                <div className="info">
                                  <h4>{item.title}</h4>
                                  <p>
                                  <div dangerouslySetInnerHTML={{ __html: item.short_info }} /> 

                                  </p>
                                  <Link to={base_url+`products/${item.category}`}>Read More</Link>
                                </div>
                            </div>
                            <div className="info">
                                <div className="content">
                                    <div className="top-info">
                                        <h4><Link to={base_url+`products/${item.category}`}>{item.title}</Link></h4>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    ))}
                       
                    </div>
                </div>
            </div>
        </div>
    </div>
       
    );
}

}

export default ProductsHome;